var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Prop, Component, Mixins, } from 'vue-property-decorator';
import { useStore } from 'vuex-simple';
import LayoutMixin from '@/mixins/layout-mixin';
import debounce from '@/utils/tiny-debounce';
var BaseTable = /** @class */ (function (_super) {
    __extends(BaseTable, _super);
    function BaseTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.expanded = [];
        _this.store = useStore(_this.$store);
        // search items
        _this.searchVisible = false;
        _this.searchTerm = '';
        _this.debouncedSearchTerm = '';
        // debounce the search term update by 500ms
        _this.debouncedSearchTermFunction = debounce(function (val) {
            this.debouncedSearchTerm = val;
        }, 500);
        // settings
        _this.settingsMenu = false;
        return _this;
    }
    Object.defineProperty(BaseTable.prototype, "tableLoading", {
        // loading indicator for items
        get: function () {
            return this.loading || this.store.loading;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseTable.prototype, "tableItems", {
        get: function () {
            if (this.tableLoading) {
                return [];
            }
            else {
                return this.items || this.store.items.filteredItemsByDeleted;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseTable.prototype, "readonly", {
        get: function () {
            return this.store.managementPage.readonly;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseTable.prototype, "fixedHeight", {
        get: function () {
            if (this.disableFixedHeight) {
                return false;
            }
            return this.store.items.tableOptions.fixedHeight;
        },
        set: function (payload) {
            this.store.items.setTableFixedHeight(payload);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseTable.prototype, "height", {
        get: function () {
            if (this.fixedHeight) {
                return this.approxTableHeight;
            }
            else {
                return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseTable.prototype, "currentPage", {
        get: function () {
            return this.store.items.tablePagination.page;
        },
        set: function (payload) {
            this.store.items.setPaginationPage(payload);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseTable.prototype, "itemsPerPage", {
        get: function () {
            return this.store.items.tablePagination.itemsPerPage;
        },
        set: function (payload) {
            this.store.items.setPaginationItemsPerPage(payload);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseTable.prototype, "internalDisablePagination", {
        get: function () {
            return this.disablePagination || this.store.items.tablePagination.disabled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseTable.prototype, "multiSort", {
        get: function () {
            return this.store.items.tableOptions.multiSort;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseTable.prototype, "internalSortBy", {
        get: function () {
            if (this.overrideSorting) {
                return this.sortBy;
            }
            return this.store.items.tableOptions.sortBy;
        },
        set: function (payload) {
            if (this.overrideSorting) {
                this.$emit('update:sortBy', payload);
            }
            else {
                this.store.items.setTableOptionsSortBy(payload);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseTable.prototype, "internalSortDesc", {
        get: function () {
            if (this.overrideSorting) {
                return this.sortDesc;
            }
            return this.store.items.tableOptions.sortDesc;
        },
        set: function (payload) {
            if (this.overrideSorting) {
                this.$emit('update:sortDesc', payload);
            }
            else {
                this.store.items.setTableOptionsSortDesc(payload);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseTable.prototype, "footerOptions", {
        get: function () {
            return {
                itemsPerPageOptions: this.store.items.tablePagination.itemsPerPageOptions,
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseTable.prototype, "approxTableHeight", {
        get: function () {
            return this.contentSize.y - 200 + this.heightAdjustment;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseTable.prototype, "addButtonVisible", {
        get: function () {
            if (this.hideAddButton) {
                return false;
            }
            return this.store.managementPage.readonly === false;
        },
        enumerable: false,
        configurable: true
    });
    BaseTable.prototype.handleSearchChange = function (searchTerm) {
        this.debouncedSearchTermFunction(searchTerm);
    };
    BaseTable.prototype.toggleExpanded = function (props) {
        props.expand(!props.isExpanded);
    };
    BaseTable.prototype.toggleSearchVisibility = function () {
        var _this = this;
        this.searchVisible = !this.searchVisible;
        if (this.searchVisible === true) {
            this.$nextTick(function () {
                var searchInput = _this.$refs.searchInput;
                searchInput.focus();
            });
        }
    };
    BaseTable.prototype.toggleFilterSidesheet = function () {
        var _this = this;
        if (this.store.managementPage.crudSidesheetVisible) {
            this.store.managementPage.closeCrudSidesheet();
        }
        this.$nextTick(function () {
            _this.store.managementPage.filterSidesheetVisible
                ? _this.store.managementPage.closeFilterSidesheet()
                : _this.store.managementPage.openFilterSidesheet();
        });
    };
    __decorate([
        Prop({ type: Array, required: true }),
        __metadata("design:type", Array)
    ], BaseTable.prototype, "headers", void 0);
    __decorate([
        Prop({ type: String, required: false, default: 'fas fa-list' }),
        __metadata("design:type", String)
    ], BaseTable.prototype, "icon", void 0);
    __decorate([
        Prop({ type: Boolean, required: false, default: false }),
        __metadata("design:type", Boolean)
    ], BaseTable.prototype, "condensed", void 0);
    __decorate([
        Prop({ type: [String, Array], required: false, default: null }),
        __metadata("design:type", Object)
    ], BaseTable.prototype, "sortBy", void 0);
    __decorate([
        Prop({ type: [Boolean, Array], required: false, default: null }),
        __metadata("design:type", Object)
    ], BaseTable.prototype, "sortDesc", void 0);
    __decorate([
        Prop({ type: Boolean, required: false, default: false }),
        __metadata("design:type", Boolean)
    ], BaseTable.prototype, "overrideSorting", void 0);
    __decorate([
        Prop({
            type: Object,
            required: false,
            default: function () { return ({
                dense: false,
                color: 'blue-grey darken-2',
            }); },
        }),
        __metadata("design:type", Object)
    ], BaseTable.prototype, "toolbarOptions", void 0);
    __decorate([
        Prop({
            type: Boolean,
            required: false,
            default: false,
        }),
        __metadata("design:type", Boolean)
    ], BaseTable.prototype, "denseToolbar", void 0);
    __decorate([
        Prop({
            type: String,
            required: false,
            default: 'blue-grey darken-2',
        }),
        __metadata("design:type", Boolean)
    ], BaseTable.prototype, "colorToolbar", void 0);
    __decorate([
        Prop({
            type: Array,
            required: false,
        }),
        __metadata("design:type", Array)
    ], BaseTable.prototype, "items", void 0);
    __decorate([
        Prop({
            type: Boolean,
            required: false,
        }),
        __metadata("design:type", Boolean)
    ], BaseTable.prototype, "loading", void 0);
    __decorate([
        Prop({
            type: Boolean,
            required: false,
            default: false,
        }),
        __metadata("design:type", Boolean)
    ], BaseTable.prototype, "flat", void 0);
    __decorate([
        Prop({
            type: Boolean,
            required: false,
            default: false,
        }),
        __metadata("design:type", Boolean)
    ], BaseTable.prototype, "hideAddButton", void 0);
    __decorate([
        Prop({ type: Boolean, required: false, default: false }),
        __metadata("design:type", Boolean)
    ], BaseTable.prototype, "hideFilterIcon", void 0);
    __decorate([
        Prop({ type: Boolean, required: false, default: false }),
        __metadata("design:type", Boolean)
    ], BaseTable.prototype, "disablePagination", void 0);
    __decorate([
        Prop({ type: Boolean, required: false, default: false }),
        __metadata("design:type", Boolean)
    ], BaseTable.prototype, "disableFixedHeight", void 0);
    __decorate([
        Prop({ type: Boolean, required: false, default: false }),
        __metadata("design:type", Boolean)
    ], BaseTable.prototype, "hideSettings", void 0);
    __decorate([
        Prop({ type: Number, required: false, default: 0 }),
        __metadata("design:type", Number)
    ], BaseTable.prototype, "heightAdjustment", void 0);
    BaseTable = __decorate([
        Component
    ], BaseTable);
    return BaseTable;
}(Mixins(LayoutMixin)));
export default BaseTable;
